import { render } from "./VouchersView.vue?vue&type=template&id=3c405f48"
import script from "./VouchersView.vue?vue&type=script&lang=js"
export * from "./VouchersView.vue?vue&type=script&lang=js"

import "./VouchersView.vue?vue&type=style&index=0&id=3c405f48&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__